'use client'

import Link from 'next/link'

import TanstackProvider from '@/_providers/TanstackProvider'
import { LinkProvider, MDividerImagesA, MHeroA, MTextA } from '@medante/react-components'

import type { IMDividerImagesAProps } from '@medante/react-components/blocks/divider/divider-images-a'
import type { IMHeroAProps } from '@medante/react-components/blocks/hero/hero-a'
import type { IMTextAProps } from '@medante/react-components/blocks/text/text-a'

import { AAnnualProgramPreviewAnalytics } from './a-annual-program-preview-analytics'

const ARenderBlocks = (config: any) => {
	try {
		return config.blocks.map((block: any, index: number) => {
			switch (block.type) {
				case 'MHeroA':
					return <MHeroA key={`block-${index}`} {...(block.data as IMHeroAProps)} />
				case 'MDividerImagesA':
					return (
						<MDividerImagesA
							key={`block-${index}`}
							{...(block.data as IMDividerImagesAProps)}
						/>
					)
				case 'MTextA':
					return <MTextA key={`block-${index}`} {...(block.data as IMTextAProps)} />
				case 'MAnnualProgramPreview':
					return (
						<AAnnualProgramPreviewAnalytics
							key={`block-${index}`}
							{...block.data}
						/>
					)
				default:
					return null
			}
		})
	} catch (error: unknown) {
		if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true') {
			void import('@sentry/nextjs').then(({ captureException }) => {
				captureException(error)
			})
		}
		return null
	}
}

export default function AAPContent({ config }: { config: any }) {
	return (
		<TanstackProvider>
			<LinkProvider value={Link as any}>{ARenderBlocks(config)}</LinkProvider>
		</TanstackProvider>
	)
}
